module.exports = __webpack_public_path__ + "static/media/Icon_Technology1.c9c9dff0.svg";